import { authenticatedFetch } from "./apiClient";

export interface IdeaGenerationRequest {
  domain_id: string;
  user_input: string;
}

export interface IdeaGenerationResponse {
  success: boolean;
  message: string;
  job_id: string;
}

export class IdeaGenerationService {
  static async generateIdeas(
    request: IdeaGenerationRequest,
  ): Promise<IdeaGenerationResponse> {
    const response = await authenticatedFetch(
      `${import.meta.env.VITE_API_URL}/v1/generations/ideas`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(request),
      },
    );

    if (!response.ok) {
      throw new Error(`Generation failed: ${response.statusText}`);
    }

    return response.json();
  }
}
